import { render } from "./DeviceList.vue?vue&type=template&id=645f10be&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"

import "./DeviceList.vue?vue&type=style&index=0&id=645f10be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645f10be"]])

export default __exports__